// extracted by mini-css-extract-plugin
export default {"repeatedTextBanner":"Twb_r","partOfProductGallery":"ZhPCM","access-view":"eHsYo","access-purchase":"_DUBc","bannerText":"ZWooV"};